import React, { useMemo } from 'react';
import VirtualizedProductList from './VirtualizedProductList';

const VirtualizedProductListByCategory = ({
  categories = [],
  branchConfig,
  onAdd,
  onMinus,
  onProductClick,
  getProductQuantity,
}) => {
  const validCategories = useMemo(() => {
    if (!categories || !Array.isArray(categories)) return [];
    return categories.filter(
      cat =>
        cat &&
        cat.productDTOList &&
        Array.isArray(cat.productDTOList) &&
        cat.productDTOList.length > 0
    );
  }, [categories]);

  if (validCategories.length === 0) {
    return (
      <div className="carta-v7-empty">
        <p>No hay productos disponibles en las categorías seleccionadas</p>
      </div>
    );
  }

  return (
    <>
      {validCategories.map((category, index) => {
        const products = category.productDTOList.filter(p => p && p.id);
        return (
          <div className="carta-v7-category-block" key={category.id || index}>
            <div className="carta-v7-category-block__header">
              <h3 className="carta-v7-category-block__title">{category.name || 'Sin nombre'}</h3>
              <div className="carta-v7-category-block__line" />
            </div>
            <VirtualizedProductList
              products={products}
              branchConfig={branchConfig}
              onAdd={onAdd}
              onMinus={onMinus}
              onProductClick={onProductClick}
              getProductQuantity={getProductQuantity}
            />
          </div>
        );
      })}
    </>
  );
};

export default VirtualizedProductListByCategory;
